import React from "react";

export const LotusMark = ({ className = "", size = 40 }) => (
  <img
    src="/lotus.png"
    alt=""
    aria-hidden="true"
    className={className}
    style={{ height: size, width: "auto" }}
  />
);

export const Logo = ({ light = false, compact = false }) => {
  const green = light ? "#F6F3E9" : "#1F4A34";
  const gold = "#B8893C";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/lotus.png"
        alt="Holistic Wellness & Aesthetics"
        className={compact ? "h-9 w-auto" : "h-12 w-auto"}
      />
      <div className="leading-none">
        <div
          className="font-serif tracking-wide"
          style={{ color: green, fontSize: compact ? "1rem" : "1.15rem", letterSpacing: "0.06em" }}
        >
          HOLISTIC WELLNESS
        </div>
        <div
          className="font-serif tracking-widest"
          style={{ color: gold, fontSize: compact ? "0.7rem" : "0.8rem", letterSpacing: "0.22em" }}
        >
          &amp; AESTHETICS
        </div>
      </div>
    </div>
  );
};
